import React, { useMemo } from "react";
import { map } from "utils/lodashUtils";
import { ALL_SEVERITIES } from "views/Findings/Constants";

import ACSeverityTag, { SeverityType } from "ac-components/ACSeverityTag";

interface SeverityOption {
  label: JSX.Element;
  value: string;
}

export default function useSeveritiesOptions({
  valueCase,
}: {
  valueCase?: "upper" | "lower";
} = {}) {
  const severityOptions: SeverityOption[] = useMemo(() => {
    return map(ALL_SEVERITIES, (severity) => {
      return {
        label: <ACSeverityTag value={severity as SeverityType} />,
        value:
          valueCase === "lower"
            ? severity.toLowerCase()
            : valueCase === "upper"
              ? severity.toUpperCase()
              : severity,
      };
    });
  }, [valueCase]);
  return severityOptions;
}
